<template>
  <section class="input-structured-text">

     <section class="editor" v-if="value">
      <div class="object" v-for="(components, componentIndex) in value" :key="`${unique}componenents${componentIndex}`">

        <div class="atom" v-for="component in components" :key="`${unique}${component.type}${component.id}`">
          <component v-if="unique && component.type"
            :is="component.type" :cid="component.id" v-model="component.props"
            :key="`Component${unique}${component.type}${component.id}`"
            @meta="$set(editMetaVisible, componentIndex, true)"
            :edit="editAtomVisible[componentIndex]">
          </component>
        </div>

        <div class="more" v-if="max > 1">
          <span @click="removeAtom(componentIndex)"><i class="el-icon-delete"/></span>
          <span v-if="value.length <= max" @click="$set(addTemplateVisible, componentIndex, true)"><i class="el-icon-circle-plus-outline"/></span>
        </div>

        <el-dialog :key="`dialog${componentIndex}`" title="Ajouter un élément" :visible.sync="addTemplateVisible[componentIndex]" :append-to-body="true">
          <el-radio-group v-model="position" size="mini">
            <el-radio-button label="after">Après l'élément</el-radio-button>
            <el-radio-button label="before">Avant l'élément</el-radio-button>
          </el-radio-group>
          <div class="add-element">
            <span v-for="template in templates" :key="`template${template.label}`" @click="addTemplate(template, componentIndex)">
              <i class="material-icons">add_box</i><br>{{ template.label }}
            </span>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="addTemplateVisible[index] = false" size="small">Annuler</el-button>
          </span>
        </el-dialog>

      </div>

    </section>

  </section>
</template>

<script>
import AtomStructuredText from './richtext-atoms/AtomStructuredText.vue';
import AtomImage from './richtext-atoms/AtomImage.vue';
import AtomSimpleText from './richtext-atoms/AtomSimpleText.vue';

export default {
  name: 'input-structured-text',
  components: {
    AtomStructuredText,
    AtomImage,
    AtomSimpleText,
  },
  props: ['value', 'config'],
  data() {
    return {
      unique: Math.floor(Math.random() * Math.floor(100000)),
      addTemplateVisible: {},
      editMetaVisible: {},
      editAtomVisible: {},
      removeAtomVisible: {},
      position: 'after',

      templates: null,
      max: 0,
    };
  },
  created() {
    let validations = {};
    this.config.validations.forEach((validation) => {
      validations = { ...validations, ...validation };
    });
    this.templates = validations.templates;
    this.max = validations.max || 10;
    this.initData();
  },
  watch: {
    value: 'initData',
  },
  methods: {
    initData() {
      if (this.value.length === 0) {
        this.addTemplate(this.templates[0], 0);
      }
    },
    addTemplate(template, i) {
      const index = (this.position === 'after') ? i + 1 : i;
      this.value.splice(index, 0, {});
      const objects = [];
      template.items.forEach((element) => {
        objects.push({ id: Math.floor(Math.random() * Math.floor(100000)), type: `Atom${element}`, props: {} });
      });
      this.$set(this.value, index, objects);
      this.$emit('input', this.value);
      this.addTemplateVisible[i] = false;
      this.$forceUpdate();
    },
    async removeAtom(index) {
      try {
        await this.$confirm('Voulez-vous bien supprimer cet élément ?', 'Suppresion de l’élement');
        if (this.value.length > 1) {
          this.value.splice(index, 1);
          this.$emit('input', this.value);
          this.$forceUpdate();
        } else {
          this.$message({
            type: 'error',
            message: 'Impossible de supprimer le dernier élément',
          });
        }
      } catch (error) {
        // Rien à faire mais le linter est penible
      }
    },
  },
};
</script>

<style lang="sass">
.input-structured-text
  background: white
  div
    box-sizing: border-box

  .object
    position: relative
    &.multiple
      border-left: 2px dashed lighten(#ff3c48, 20%)
    .number
      position: absolute
      display: flex
      align-items: center
      justify-content: center
      top: 0
      left: -2px
      width: 20px
      height: 20px
      background: lighten(#ff3c48, 20%)
      color: white
      font-size: 0.7rem
      font-weight: bold
      border-radius: 0 2px 60% 0
      z-index: 100

    .more
      position: absolute
      right: 0
      top: 0
      bottom: 0
      padding: 0.5rem
      background: #DADADA
      > span
        display: block
        padding: 0.4rem
        background: white
        font-size: 0.7rem
        & ~ span
            margin-top: 0.2rem

  .atom
    position: relative
    margin: 0.5rem 0
    padding-right: 50px
    min-height: 110px
    border-left: 4px solid transparent
    transition: all ease-in 0.2s
    background: #FAFAFA

    .input-media
      display: flex
      align-items: center
      justify-content: center
      min-height: 80px

    .edit
      position: absolute
      top: 0
      left: 0
      right: 40px
      display: flex
      text-align: left
      padding: 0.45rem 0.5rem 0.3rem
      background: #EAEAEA
      .meta
        margin-right: 4px
        width: 110px
      i
        font-size: 16px
      .el-button-group
        display: flex
        flex: 1 1 0
        .el-button+.el-button
          margin: 0
      .edit-atom
        display: flex
        flex: 1 1 0
        justify-content: flex-end
      ~ div
        margin-top: 50px
      button, .el-radio-button__inner
        padding: 0.4rem 0.4rem 0.3rem
      .el-radio-group
        .el-radio-button
          display: inline-block
          margin: 0
          padding: 0
          &:focus
            outline: 0

    &:hover
      border-left: 4px solid #EAEAEA
      background: #fafafa

  &:hover
    > .editor > .add-one
      display: block

.add-element
  margin-top: 2rem
  span
    display: inline-block
    margin: 1rem
    padding: 2.5rem 3rem
    border: 1px solid #DDDDDD
    border-radius: 4px
    background: #FAFAFA
    cursor: pointer
    i
      margin-bottom: 0.5rem

.add-meta
  .el-input
    width: 60%
</style>
